/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { localize2 } from '../../../nls.js';
export const Categories = Object.freeze({
    View: localize2(1623, 'View'),
    Help: localize2(1624, 'Help'),
    Test: localize2(1625, 'Test'),
    File: localize2(1626, 'File'),
    Preferences: localize2(1627, 'Preferences'),
    Developer: localize2(1628, "Developer"),
});
//# sourceMappingURL=actionCommonCategories.js.map